import { Component } from 'react';

import { Box, Button } from '@mui/material';
import moment from 'moment';

import { convertMeterToMile } from '../../constants/common';
import styles from './styles';

class StopAssignmentTooltip extends Component {
  render() {
    const { stop, showAssignmentDetail } = this.props;
    const { assignment } = stop;
    const rows = [
      { label: 'ID', value: assignment.id },
      {
        label: 'Predicted',
        value: moment(assignment.predicted_start_ts).format('hh:mm a') + ' - ' + moment(assignment.predicted_end_ts).format('hh:mm a'),
      },
      { label: 'Driving', value: convertMeterToMile(assignment.travel_distance) + ' mi / ' + (assignment.travel_time / 3600).toFixed(1) + ' hours' },
      { label: 'Assigned', value: assignment.driver && assignment.driver.first_name + ' ' + assignment.driver.last_name },
      { label: 'Status', value: assignment.status },
    ];

    return (
      <Box sx={styles.container}>
        <Box sx={styles.label}>Assignment {assignment.label}</Box>
        {rows.map((row, idx) => (
          <Box sx={styles.row} key={`row-${idx}`}>
            <Box sx={styles.col_left}>{row.label}:</Box>
            <Box sx={styles.col_right}>{row.value}</Box>
          </Box>
        ))}
        <div>
          <Button variant="contained" size="small" color="primary" disableElevation onClick={() => showAssignmentDetail && showAssignmentDetail(assignment)}>
            DETAIL
          </Button>
        </div>
      </Box>
    );
  }
}

export default StopAssignmentTooltip;
